import { useState } from "react";
import "./nav.css";
import { HashLink as Link } from "react-router-hash-link";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="contain header-content">
        {/* Logo AZUREA */}
        <div className="logo">
          <Link to={"/#hero"}>
            <img
              src={require("../../logo-footer.png")}
              alt="AZUREA Print & Solutions"
            />
          </Link>
        </div>

        {/* Navigation */}
        <nav className={`navigation ${menuOpen ? "active" : ""}`}>
          <Link to="/#apropos" className="nav-link nav-link-active">
            À PROPOS
          </Link>
          <Link to="/#prestations" className="nav-link">
            PRESTATIONS
          </Link>
          <Link to="/#contact" className="nav-link">
            CONTACT
          </Link>
        </nav>

        {/* Burger icon */}
        <div
          className={`burger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
}
